// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_Umy","cls2":"CitationModal-cls2_1EZ CitationModal-cls1_Umy"};